export default "__VITE_ASSET__CaoijkB$__"